module.exports = __webpack_public_path__ + "static/media/reminder_White.99fd0224.png";